import React from "react"
import { BraintreeHostedFields } from "../../../components/braintree"
import { useOrderStore } from "../../../store/hooks/useStore"
import { PAYMENT_METHOD_IDS } from "../../../utils/constants"
import { Box, Checkbox, Flex, Stack } from "../../../vanilla"
import { CheckoutButton } from "./checkout-button"
import { PaymentMethod } from "./payment-method"
import { PaymentMethodButton } from "./payment-method-button"
import { PaymentMethodAccordionProps } from "../../../types/checkout"
import { usePaymentMethodData } from "../../../hooks/use-payment-method-data"
import { observer } from "mobx-react"

const PMAccordion = (props: PaymentMethodAccordionProps) => {
  const {
    selectedPayment,
    setSelectedPayment,
    paymentMethod,
    bonusCardStatus,
    // Credit
    braintreeInputs,
    hostedFieldsValidationErrors,
    inputRefs,
    setSaveCreditCard,
    submitOrderProcess,
    isTopUp,
    braintreeFormIsValid = false,
    hostedFieldsErrors = false,
    savedCardEnabled = false,
    allowSaveCreditCard = false,
    usingSavedCard = false
  } = props
  const orderStore = useOrderStore()
  const {
    isAvailable,
    isDisabled,
    isLoading,
    name,
    customIconURL
  } = usePaymentMethodData(paymentMethod)
  const isSelected = selectedPayment === paymentMethod.id
  const isPayPal = paymentMethod.id === PAYMENT_METHOD_IDS.PAYPAL
  const isKlarna = paymentMethod.id === PAYMENT_METHOD_IDS.KLARNA

  return !isAvailable ? <></> : (
    <Box
      key={paymentMethod.id}
      border="1px"
      borderRadius="base"
      borderColor={isSelected ? 'accent3' : 'gray200'}
      borderTop={bonusCardStatus?.hidePayment || orderStore.isPaymentRefunding ? '0px' : '1px'}
      paddingX="12px"
      paddingY="4px"
    >
      <PaymentMethod
        method={name}
        checked={isSelected}
        type={paymentMethod.name}
        onClick={() => setSelectedPayment(paymentMethod.id)}
        customIconURL={customIconURL}
      />

      {paymentMethod.id === PAYMENT_METHOD_IDS.BT_CREDIT_CARD && (
        <Stack
          gap="12px"
          display={paymentMethod.id === PAYMENT_METHOD_IDS.BT_CREDIT_CARD && isSelected ? 'block' : 'none'}
          borderTop="1px"
          borderColor="border1"
          marginTop="4px"
          paddingY="16px"
          paddingX="24px"
        >
          <BraintreeHostedFields
            usingSavedCard={usingSavedCard}
            braintreeInputs={braintreeInputs}
            validationError={hostedFieldsValidationErrors}
            inputRefs={inputRefs.current}
          />
          {savedCardEnabled
            && allowSaveCreditCard
            && (
              <Box marginTop="8px" height="auto">
                <Checkbox
                  id="save-this-credit-payment-method"
                  defaultChecked={false}
                  label="Save this card"
                  hasError={false}
                  onChange={(e) => setSaveCreditCard(e.target.checked)}
                />
              </Box>
            )}
        </Stack>
      )}
      <Box
        padding="24px"
        display={isSelected ? 'block' : 'none'}
        borderTop={isPayPal ? '1px' : 'none'}
        borderColor="border1"
      >
        <Flex justifyContent="space-between">
          <Stack
            width={['full', '300px']}
            marginTop={isPayPal ? '28px' : '0px'}
          >
            {paymentMethod.id === PAYMENT_METHOD_IDS.BT_CREDIT_CARD ? (
              <CheckoutButton
                submitOrderProcess={submitOrderProcess}
                isEditModeEnabled={false}
                billingAddressFormValid={true}
                isPaymentRefunding={orderStore.isPaymentRefunding}
                braintreeFormIsValid={braintreeFormIsValid}
                bonusCardStatus={bonusCardStatus}
                hostedFieldsErrors={hostedFieldsErrors}
                isTopUp={isTopUp}

              />
            ) : (
              <PaymentMethodButton containerId={`${paymentMethod.id}-container-${1}`} backgroundColor={isPayPal ? 'paypalButton' : isKlarna ? 'none' : 'black'} isLoading={isLoading} disabled={isDisabled} />
            )}
          </Stack>
        </Flex>
      </Box>
    </Box>
  )
}

export const PaymentMethodAccordion = observer(PMAccordion)